import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { MessageService } from '../../../services';

@Component({
    selector: 'Logout',
    templateUrl: './logout.component.html'
})

export class LogoutComponent implements OnInit {

    constructor(private router: Router,
        private _messageService: MessageService) { }

    ngOnInit() {
        localStorage.removeItem('AuthToken');
        this._messageService.loadCurrentUserProfile();
        this.router.navigate(['/account/login']);
    }
}



// WEBPACK FOOTER //
// ./src/components/account/logout/logout.component.ts